var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-preview",on:{"click":_vm.routeProject}},[_c('Chip',{attrs:{"label":_vm.featurePreviewContent.label,"id":_vm.featurePreviewContent.id}},[_c('img',{attrs:{"src":_vm.featurePreviewContent.thumbnail}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }